import { render, staticRenderFns } from "./GroupTalksPage.vue?vue&type=template&id=ddd3dd50&scoped=true&"
import script from "./GroupTalksPage.vue?vue&type=script&lang=js&"
export * from "./GroupTalksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd3dd50",
  null
  
)

export default component.exports